import { defineComponent as _defineComponent } from 'vue'
import {WarrantyService} from '../../../services/WarrantyService'
import {onMounted, ref} from "vue";
import {useRouter} from 'vue-router/composables'
import i18n from "@/i18n";
import {WarrantyUserType} from "@/types/WarrantyUserType";
import {store} from "@/store";
import {WarrantyLocationInfoService} from "@/services/WarrantyLocationInfoService";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCreate',
  setup(__props) {

const router = useRouter()
const message = ref<string | (string | null)[]>('')
const messageType = ref<string | (string | null)[]>('')
const snackbar = ref<boolean>(false)

const user = ref<WarrantyUserType | any>({})

const validation = ref({
    firstname: false,
    lastname: false,
    email: false,
    zip: false,
    city: false,
    street: false,
    country: false,
    phone: false,
    locale: false,
})

onMounted(() => {
    WarrantyLocationInfoService.getCountries()
})

function selectCountry(country:string) {
    WarrantyLocationInfoService.getLocales(country)
}

function removeWhiteSpace(text:string) {
  return text.trim();
}

function saveUser() {
    message.value = ''
    if (validataUser(user.value)) {
        WarrantyService.createUser(user.value)
            .then(value => {
              console.log(value)
              if (value['error'] !== undefined) {
                  displayMessage(value['error'])
              } else {
                router.push({
                  name: 'warranty_user_detail',
                  params: {id: value}
                })
              }
            })
            .catch(reason => {
              console.log(reason)
                if (reason['error'] !== undefined) {
                    displayMessage(reason['error'])
                } else {
                    displayMessage('Some inputs are invalid', 'error')
                }
            });
    }
}

function validataUser(user: WarrantyUserType): boolean {
    validation.value.email = false
    validation.value.firstname = false
    validation.value.lastname = false
    validation.value.zip = false
    validation.value.city = false
    validation.value.street = false
    validation.value.country = false
    validation.value.locale = false
    console.log(user.firstname)
    let valid = true
    if (!user.email) {
        validation.value.email = true
        valid = false
    }
    if (!user.firstname) {
        validation.value.firstname = true
        valid = false
    }
    if (!user.lastname) {
        validation.value.lastname = true
        valid = false
    }
    if (!user.zip) {
        validation.value.zip = true
        valid = false
    }
    if (!user.city) {
        validation.value.city = true
        valid = false
    }
    if (!user.street) {
        validation.value.street = true
        valid = false
    }
    if (!user.country) {
        validation.value.country = true
        valid = false
    }
    if (!user.locale) {
        validation.value.locale = true
        valid = false
    }

    return valid
}

const displayMessage = (messageString: string | (string | null)[], type: string = "warning") => {
    message.value = messageString
    messageType.value = type
    snackbar.value = true
}

return { __sfc: true,router, message, messageType, snackbar, user, validation, selectCountry, removeWhiteSpace, saveUser, validataUser, displayMessage, i18n, store }
}

})